import * as React from 'react'
import './footer.css'
import { FacebookQuickMessage } from '../facebook-quick-message'
import { NewsLetter } from '../news-letter'
import { documentToHtmlString } from '@contentful/rich-text-html-renderer'

export default class Footer extends React.Component<any> {
  constructor(props: any) {
    super(props)
    this.state = {}
  }

  render() {
    const content = this.props.content

    return (
      <footer>
        <div className="upper item-container">
          <div className="items-3 gutter">
            <img src="/images/Logo.svg" className="logo" alt="logo" />
            <div
              dangerouslySetInnerHTML={{
                __html: documentToHtmlString(
                  content !== undefined && content[0].fields.text,
                ).replace(/(?:\r\n|\r|\n)/g, '<br />'),
              }}
            />
          </div>
          <div
            className="items-3 gutter secondFooterText"
            dangerouslySetInnerHTML={{
              __html: documentToHtmlString(
                content !== undefined && content[0].fields.secondText,
              ).replace(/(?:\r\n|\r|\n)/g, '<br />'),
            }}
          />
          <div className="items-3">
            <NewsLetter />
          </div>
        </div>
        <div className="lower item-container">
          <span>©{new Date().getFullYear()} Ebson ehf</span>
          <span>Allur réttur áskilinn</span>
        </div>
        <FacebookQuickMessage />
      </footer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Shared/footer/footer.tsx